import React, { useEffect, useState } from 'react';

//Header Data

import { getUserInspirationPageNumber } from '../../../store/Selectors';
import DslStore from '../../../store/DslStore';
import { useStoreState } from 'pullstate';
import styles from '../Profile.module.scss';

import AddInspirationCard from '../../../components/Inspirations/InspirationCard/AddInspirationCard';

import { Inspiration, User } from '../../../global';
import axiosHelper from '../../../helpers/axiosHelper';
import NewInspirationCard from '../../../components/Inspirations/InspirationCard/NewInspirationCard';
import InspirationEditor from '../../../components/Inspirations/InspirationEditor';
import { set } from 'react-hook-form';
import { all } from 'axios';

interface ProfileProps {
  user: User;
  loggedUser: User | null;

  breadcrumbs: (breadcrumbs: string) => void;
}

const InspirationsWLF: React.FC<ProfileProps> = ({ user, loggedUser, breadcrumbs }) => {
  const [editMode, setEditMode] = useState(false);
  const [editedInspiration, setEditedInspiration] = useState<Inspiration | null>(null);
  // const [key, setKey] = useState(0);
  // const currentUser = useStoreState(DslStore, getCurrentUser);
  // const allInspirations = useStoreState(DslStore, getUserInspirations);
  // const allFavoriteInspirations = useStoreState(DslStore, getUserInspirationsFavorites);
  const pageNumber = useStoreState(DslStore, getUserInspirationPageNumber);
  // const communityUser = useStoreState(DslStore, getCommunityUser);
  const [allInspirations, setAllInspirations] = useState<Inspiration[]>([]);
  const [allFavoriteInspirations, setAllFavoriteInspirations] = useState<Inspiration[]>([]);
  const [visibleInspirationsFavorite, setVisibileInspirationsFavorite] = useState<Inspiration[]>([]);
  const [userFavoriteInspirations, setUserFavoriteInspirations] = useState<Inspiration[]>([]);
  const [visibleInspirations, setVisibleInspirations] = useState<Inspiration[]>([]);
  useEffect(() => {
    if (user) {
      axiosHelper.getUserInspirations(user.id)?.then((designerInspirations) => {
        console.log(designerInspirations);
        setAllInspirations(designerInspirations);
      });
    }
  }, [user]);

  useEffect(() => {
    breadcrumbs('Inspirations');
    // inspirationsFavorites();
    // arraysfill();
    // arraysInspirationsfill();
  }, []);

  useEffect(() => {
    if (allInspirations) {
      setVisibleInspirations(allInspirations);
      if (allInspirations.length > 0) {
        // arraysInspirationsfill();
      }
    }
  }, [allInspirations]);

  const arraysfill = () => {
    let chunkSize = 19;
    let startchunk = (pageNumber - 1) * chunkSize;
    let tempArray: Inspiration[] = [];
    let removePrivate: Inspiration[] = [];
    allInspirations.map((item) => {
      if (item.isPrivate) {
        // if (currentUser?.id === communityUser?.id) {
        // removePrivate.push(item);
        // }
      } else {
        removePrivate.push(item);
      }
    });
    const chunk: Inspiration[] = removePrivate.slice(startchunk, startchunk + chunkSize);

    for (let i = 0; i < allInspirations.length; i += chunkSize) {
      const chunk: Inspiration[] = removePrivate.slice(startchunk, startchunk + chunkSize);
    }
    for (let i = 0; i < chunkSize; i++) {
      if (chunk[i] != undefined) {
        tempArray.push(chunk[i]);
      } else {
        break;
      }
    }
    // currentUser?.id === communityUser?.id && tempArray.unshift(firstInspiration);
    setVisibleInspirations(tempArray);
  };

  const arraysInspirationsfill = () => {
    console.log('favorite fill');
    // let chunkSize = 20;
    // let startchunk = (pageNumber - 1) * chunkSize;
    // let tempArray: InspirationVotes[] = [];
    // const chunk: InspirationVotes[] = allFavoriteInspirations.slice(startchunk, startchunk + chunkSize);

    // for (let i = 0; i < allFavoriteInspirations.length; i += chunkSize) {
    //   const chunk: InspirationVotes[] = allFavoriteInspirations.slice(startchunk, startchunk + chunkSize);
    // }
    // for (let i = 0; i < chunkSize; i++) {
    //   if (chunk[i] !== undefined) {
    //     tempArray.push(chunk[i]);
    //   } else {
    //     break;
    //   }
    // }
    // console.log(tempArray);

    // setVisibileInspirationsFavorite(tempArray);
    // setKey(key + 1);
  };

  // useEffect(() => {
  //   setVisibleInspirations(allInspirations);
  //   console.log('sono cambiate e faccio arrayFill NORMALE');
  //   arraysfill();
  // }, [allInspirations]);

  // useEffect(() => {
  //   setVisibleInspirations(allInspirations);

  //   arraysfill();
  // }, [pageNumber]);
  const createNewInspiration = () => {
    setEditedInspiration(null);
    setEditMode(true);
  };
  const editInspiration = (inspiration: Inspiration) => {
    setEditedInspiration(inspiration);
    setEditMode(true);
  };
  const didVoteCallback = (votedInspiration: Inspiration) => {
    if (votedInspiration) {
      setAllInspirations((prevInspirations) => prevInspirations.map((inspiration) => (inspiration.id === votedInspiration.id ? votedInspiration : inspiration)));
    }
  };

  const saveCallback = (newInspiration: Inspiration | null) => {
    if (newInspiration) {
      setAllInspirations((prevInspirations) => {
        if (editedInspiration) {
          // Editing an existing inspiration
          return prevInspirations.map((inspiration) => (inspiration.id === newInspiration.id ? newInspiration : inspiration));
        } else {
          // Creating a new inspiration
          return [newInspiration, ...prevInspirations];
        }
      });
    }
    setEditMode(false);
  };
  return (
    <div className="bg-light-gray stocazzo">
      <main className={`${styles.profileWrapper} stocazzo container pt-5  mb-5 px-sm-0 `}>
        <div className={`row stocazzo`}>
          {editMode ? (
            <InspirationEditor inspiration={editedInspiration} saveCallback={saveCallback} closeCallback={() => setEditMode(false)} />
          ) : (
            <>
              {/* <DesignerInspirationNavigation /> */}

              <div className="row pt-5 px-0 ps-1">
                <AddInspirationCard disabled={false} clickCallback={createNewInspiration} />

                {visibleInspirations?.map((aInspiration: Inspiration, index: number) => (
                  <NewInspirationCard
                    changeCallback={didVoteCallback}
                    inspiration={aInspiration}
                    loggedUser={loggedUser}
                    shownInUserProfile={true}
                    key={index}
                    editCallback={editInspiration}
                  />
                ))}
              </div>

              <div className="row mt-3 px-4"></div>
              <div className="row ">
                <div className="col-12 px-4 d-flex justify-content-sm-start justify-content-md-end ">
                  {/* {visibleInspirations.length > 0 ? <PaginationSwitch onChangePage={setUserInspirationsPageNumber} /> : ''} */}
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default InspirationsWLF;
